import { isEmpty } from 'lodash'

// =============================================================================
// Maps a prompt's segments to the canonical full-text string an inline comment
// anchors into, plus where each segment's *content* starts in that string.
//
// The base string mirrors how the BE stores a prompt: visible content verbatim,
// system content wrapped in <system>…</system>. It is built over the UNFILTERED
// segment list so an offset stays valid even though SegmentedPromptDisplay hides
// noise segments — a mark's absolute offset still resolves to the right segment.
// =============================================================================

const SYSTEM_OPEN = '<system>'
const SYSTEM_CLOSE = '</system>'

export const composeSegmentsText = (segments, fallbackText = '') => {
  const list = isEmpty(segments)
    ? [{ index: 0, type: 'visible', content: fallbackText || '' }]
    : segments

  let offset = 0
  const baseByIndex = {}
  const parts = []

  list.forEach((segment) => {
    const content = segment.content || ''
    if (segment.type === 'system') {
      baseByIndex[segment.index] = offset + SYSTEM_OPEN.length
      parts.push(`${SYSTEM_OPEN}${content}${SYSTEM_CLOSE}`)
      offset += SYSTEM_OPEN.length + content.length + SYSTEM_CLOSE.length
    } else {
      baseByIndex[segment.index] = offset
      parts.push(content)
      offset += content.length
    }
  })

  return { text: parts.join(''), baseByIndex }
}

// Clip already-resolved comment marks to one segment. `marks` are absolute
// ranges in the composed base text (`[{ id, start, end }]`, re-anchored by
// locateSnippet upstream); `base` is this segment's content offset. Ranges are
// further clipped to the content in renderTextWithMarks, so a mark spanning the
// segment boundary still paints its visible part.
export const segmentMarks = (marks, segment, baseByIndex, focusedRequestId) => {
  if (isEmpty(marks)) {
    return []
  }
  const base = baseByIndex[segment.index]
  const { length } = segment.content || ''
  return marks
    .filter((mark) => mark.end > base && mark.start < base + length)
    .map((mark) => ({
      id: mark.id,
      active: mark.id === focusedRequestId,
      draft: Boolean(mark.draft),
      start: mark.start - base,
      end: mark.end - base,
    }))
}
